import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import TextInput from "../../components/TextInput/TextInput";
import FormLayoutWrapper from "../../components/HOC/FormLayoutWrapper";
import * as sharedActions from "../../Actions/sharedActions";
import Button from "../../components/Button";
import SnackBar from "../../components/SnackBar/SnackBar";
import { bindActionCreators } from "redux";
import TextArea from "../../components/TextArea";
import DatePicker from "react-date-picker";
import Spinner from "../../components/Spinner/Spinner";
import general from "../../utils/general";
import SelectionInput from "../../components/SelectionInput/SelectionInput";
import moment from "moment";
import TimePicker from "../../components/TimePicker";
import ThemeContext from "../../context/themeContext/ThemeContext";

class AddEventCertificate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingInitialData: true,
      isLoading: false,
      accountId: props.name,
      accountType: props.role,
      errors: {},
      errorMsg: false,
      sessionData: [],
      certificateCategoryData: [],

      month: "",
      eventTime: "",
      eventDate: "",
      eventName: "",
      sessionId: "",
      description: "",
      certificateId: "",
    };
  }

  componentDidMount() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    const promises = [
      this.props.sharedActions.getDataWithoutDispatch(
        `/api/CertificateCategory/`
      ),
      this.props.sharedActions.getDataWithoutDispatch("/api/session"),
    ];

    Promise.all(promises)
      .then((success) => {
        this.setState({
          certificateCategoryData: success[0],
          sessionData: success[1].session,
          isLoadingInitialData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoadingInitialData: false });
      });
  }

  componentDidUpdate() {
    if (this.state.msg || this.state.errorMsg) {
      setTimeout(() => {
        this.setState({
          msg: false,
          errorMsg: false,
        });
      }, 3000);
    }
  }

  onHandleTimeChange = (time) => {
    this.setState({
      eventTime: time,
    });
  };

  handleChange = (date) => {
    this.setState({
      eventDate: date,
      month: general.Months[date.getMonth()],
    });
  };

  onHandleTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onHandleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const {
      month,
      eventDate,
      eventTime,
      eventName,
      sessionId,
      description,
      accountId,
      accountType,
      certificateId,
    } = this.state;

    if (
      month === "" ||
      eventDate === "" ||
      eventTime === "" ||
      eventName === "" ||
      certificateId === "" ||
      sessionId === "" ||
      description === "" ||
      accountId === "" ||
      accountType === ""
    ) {
      this.setState({
        errorMsg: true,
      });
    } else {
      this.setState({
        isLoading: true,
      });
      let date = new Date(eventDate);
      date =
        (date.getMonth() > 8
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
        "/" +
        date.getFullYear();

      let time = moment(eventTime).format("hh:mm a");

      const data = {
        month,
        date,
        time,
        eventName,
        sessionId,
        description,
        certificateId,
        accountId,
        accountType,
      };
      console.log(data);
      this.props.sharedActions
        .simpleAddRequest("/api/EventInfo/", data)
        .then((success) => {
          this.setState({
            month: "",
            eventDate: "",
            eventTime: "",
            eventName: "",
            sessionId: "",
            description: "",
            certificateId: "",
            errorMsg: false,
            isLoading: false,
            msg: "Event Added Successfully!",
          });
          this.props.snackbar();
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
        });
    }
  };

  render() {
    const {
      errors,
      isLoadingInitialData,
      sessionData,
      certificateCategoryData,
    } = this.state;

    const Form = (
      <ThemeContext.Consumer>
        {(context) => (
          <FormLayoutWrapper
            formName="Add Event"
            borderColor={context.themeColors.primaryColor}
            borderRadius={15}
            styleHead={true}
          >
            {this.state.errorMsg ? (
              <p style={{ color: "red", textAlign: "center" }}>
                Please fill the form properly
              </p>
            ) : (
              ""
            )}

            <div className="row">
              <TextInput
                feildName={"accountId"}
                inputLabelName={"Admin Name"}
                errors={errors}
                stateData={this.state}
                placeholder="Admin Name"
                readOnly={true}
                type={"text"}
                isValidte={false}
              />

              <TextInput
                feildName={"accountType"}
                inputLabelName={"Account Type"}
                errors={errors}
                stateData={this.state}
                placeholder="Account Type"
                readOnly={true}
                type={"text"}
                isValidte={false}
              />

              <TextInput
                marginTop={20}
                feildName={"eventName"}
                inputLabelName={"Event"}
                onHandleChange={this.onHandleTextChange}
                errors={errors}
                stateData={this.state}
                placeholder={"Enter Event"}
                isValidte={false}
              />

              <SelectionInput
                marginTop={20}
                feildName={"sessionId"}
                selectName={"Session"}
                onHandleChange={(e) => this.onHandleSelectChange(e)}
                errors={errors}
                optionsArrys={sessionData}
                selectedText={"Session"}
                stateData={this.state}
                // iconClassName={'fas fa-building'}
                optionType="dynamicWithPropIdAndName"
                property={"currentSession"}
                propertyId={"sessionId"}
                successflag={"successflag"}
                isValidte={false}
                // editUse={'staffEdit'}
              />

              <div class="col-md-6" style={{ marginTop: 20 }}>
                <div class="md-form mb-0">
                  <label for="email" class="">
                    <p style={{ margin: 0, color: "#000" }}>Date</p>
                  </label>
                  <br />
                  <DatePicker
                    onChange={(e) => this.handleChange(e)}
                    value={this.state.eventDate}
                    selectDateOnly
                  />
                </div>
              </div>

              <div class="col-md-6" style={{ marginTop: 20 }}>
                <div class="md-form mb-0">
                  <label for="email" class="">
                    <p style={{ margin: 0, color: "#000" }}>Time</p>
                  </label>
                  <br />
                  <TimePicker
                    className="dateTimePicker"
                    showSecond={false}
                    placeholder={"Hr-Min-(AM/PM)"}
                    name="eventTime"
                    defaultValue={null}
                    onChange={(e) => this.onHandleTimeChange(e)}
                    format={general.timeFormat}

                    // inputReadOnly
                  />
                </div>
              </div>

              <SelectionInput
                marginTop={20}
                feildName={"certificateId"}
                selectName={"Certificate"}
                onHandleChange={(e) => this.onHandleSelectChange(e)}
                errors={errors}
                optionsArrys={certificateCategoryData}
                selectedText={"Certificate"}
                stateData={this.state}
                // iconClassName={'fas fa-building'}
                optionType="dynamicWithPropIdAndName"
                property={"certificateTitle"}
                propertyId={"id"}
                successflag={"successflag"}
                isValidte={false}
                // editUse={'staffEdit'}
              />

              <TextInput
                marginTop={20}
                feildName={"month"}
                inputLabelName={"Month"}
                errors={errors}
                stateData={this.state}
                placeholder="Month"
                readOnly={true}
                type={"text"}
                isValidte={false}
              />

              <TextArea
                feildName={"description"}
                inputLabelName={"Description"}
                onHandleChange={this.onHandleTextChange}
                errors={errors}
                stateData={this.state}
                // iconClassName={'fas fa-percentage'}
                placeholder={"Add Description"}
                isValidte={false}
              />
            </div>
            <Button
              width="100%"
              buttonClass="customButton"
              btnName="Submit"
              loaderBmargin={5}
              stateData={this.state}
              marginTop={20}
              onHandleSubmit={this.onSubmit}
              margin={"0 auto"}
              textColor="white"
              btnBackColor={context.themeColors.primaryColor}
            />
          </FormLayoutWrapper>
        )}
      </ThemeContext.Consumer>
    );

    return (
      <React.Fragment>
        <SnackBar msg={this.state.msg} />
        {isLoadingInitialData ? <Spinner /> : Form}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    role: state.setUserReducer.users.role,
    name: state.setUserReducer.users.unique_name,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    sharedActions: bindActionCreators(sharedActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEventCertificate);
